export default __webpack_public_path__ + "short-videod9773e.jpg";